<template>
  <div class="clouds">
    <img
      v-for="(cloud, index) in images"
      :key="index"
      :src="require('@/assets/'+cloud+'.svg')"
      :class="getRandomClasses()"
      :style="getRandomPosition()"
      alt
    />
  </div>
</template>

<script>
export default {
  name: "Clouds",
  data() {
    return {
      images: ["cloud1", "cloud2", "cloud3", "cloud4", "cloud5", "cloud6"]
    };
  },
  methods: {
    getRandomClasses() {
      const speed = ["fast", "medium", "slow"];
      const delay = ["delay-0", "delay-1", "delay-2", "delay-5", "delay-8"];
      return (
        speed[Math.floor(Math.random() * speed.length)] +
        " cloud " +
        delay[Math.floor(Math.random() * delay.length)]
      );
    },
    getRandomPosition(){
      function getRandom(min, max) {
        return Math.random() * (max - min) + min;
      }
      return "top: " + getRandom(10, 50) + "%; width: " + getRandom(10,15) + "rem";
    }
  }
};
</script>

<style lang="scss">
@keyframes move {
  0% {
    left: -10%;
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    left: 100%;
    opacity: 0;
  }
}

.clouds {
  overflow: hidden;
  position: absolute;
  min-width: 100%;
  min-height: 100vh;
  display: block;
}
.cloud {
  position: absolute;
  width: 20rem;
  height: auto;
  top: 20%;
  left:-100%;
  &.fast {
    animation: move 30s infinite linear;
  }
  &.medium {
    animation: move 55s infinite linear;
  }
  &.slow {
    animation: move 80s infinite linear;
  }
  &.delay-2 {
    animation-delay: 2s;
  }
  &.delay-1 {
    animation-delay: 1s;
  }
  &.delay-0 {
    animation-delay: 0s;
  }
  &.delay-5 {
    animation-delay: 5s;
  }
  &.delay-8 {
    animation-delay: 8s;
  }
}
</style>